import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.product.index'),
        name: 'product.index',
        component: () =>
            import(
                /* webpackChunkName: "products" */ '@/views/products/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.product.breadcrumb.index'),
                    to: null,
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('routes.product.create'),
        name: 'product.create',
        component: () =>
            import(
                /* webpackChunkName: "products" */ '@/views/products/Create.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.product.breadcrumb.index'),
                    to: 'product.index',
                    disable: false,
                },
                {
                    text: i18n.t('routes.breadcrumb.create'),
                    to: null,
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('routes.product.edit') + '/:id',
        name: 'product.edit',
        component: () =>
            import(
                /* webpackChunkName: "products" */ '@/views/products/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.product.breadcrumb.index'),
                    to: 'product.index',
                    disable: false,
                },
                {
                    text: i18n.t('routes.breadcrumb.edit'),
                    to: null,
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
